import { forwardRef, type ButtonHTMLAttributes } from "react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { Mail } from "lucide-react";
import { useTranslation } from "@/hooks/useTranslation";

export interface EmailAuthButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  isRegister?: boolean;
  className?: string;
}

export const EmailAuthButton = forwardRef<HTMLButtonElement, EmailAuthButtonProps>(
  ({ className = "", isRegister, ...props }, ref) => {
    const { t } = useTranslation();

    return (
      <Button
        data-umami-event="email-auth-button"
        className={cn(
          "relative flex w-full items-center rounded-lg border px-3 py-2.5 text-md transition-all",
          "border-gray-300 bg-white text-[#211E1F] hover:bg-[#211E1F]/5 active:bg-muted",
          "dark:border-transparent dark:bg-black dark:text-white dark:hover:bg-white/10 dark:active:bg-muted",
          className,
        )}
        ref={ref}
        {...props}
        type="button"
      >
        <Mail className="absolute left-3 size-5" />
        <span className="flex-1 text-center">
          {isRegister ? t("auth.buttons.continue_with_email") : t("auth.buttons.login_with_email")}
        </span>
      </Button>
    );
  },
);
